export function normalizeConditionForSave(condition) {
  const { type, params = {}, ...rest } = condition;

  let normalizedParams = {};

  switch (type) {
    case "TIME_RANGE":
      normalizedParams = {
        start: params.start,
        end: params.end,
        crosses_midnight: !!params.crosses_midnight,
      };
      break;

    case "DAY_KIND":
      normalizedParams = {
        days: params.days || [],
        holidays: !!params.include_holidays,
      };
      break;

    case "EXEMPTION": {
      const map = {
        ORIGIN: "if_origin",
        DESTINATION: "if_destination",
        POINT: "if_point",
        ZONE: "if_zone",
      };

      const key = map[params.place_type];

      if (key) {
        normalizedParams[key] = params.place_value;
      }

      normalizedParams.exempt_concept = params.exempt_concept;
      break;
    }

    default:
      normalizedParams = params;
  }

  return {
    ...rest,
    type,
    params: normalizedParams,
  };
}